import './TaxInformationWidget.scss';

import React, { useCallback, useState } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Text from 'fe-design-base/atoms/Text';
import Pill from 'fe-design-base/molecules/Pill';
import { partial } from 'lodash';
import PropTypes from 'prop-types';

import Box from 'components/Box';

import { cxHelpers } from 'util/className';
import { toI18n } from 'util/i18n';

import InfoBanner from './InfoBanner';
import WithholdingAccordion from './WithholdingAccordion';
import WithholdingForm from './WithholdingForm';
const { cx, cxEl } = cxHelpers('TaxInformationWidget');

const TaxInformationWidget = ({ user, updateUserInfo, teamDrawerMode }) => {
  const [formVisibleIndex, setFormVisibleIndex] = useState({
    0: teamDrawerMode,
    1: teamDrawerMode,
  });

  const handleOnClickAddFormDetails = useCallback(
    index => {
      setFormVisibleIndex(state => ({ ...state, [index]: true }));
    },
    [setFormVisibleIndex]
  );

  const hideForm = useCallback(
    index => {
      setFormVisibleIndex(state => ({ ...state, [index]: false }));
    },
    [setFormVisibleIndex]
  );

  const showForm = useCallback(
    (form, index) =>
      teamDrawerMode
        ? !form.get('is_submitted') && formVisibleIndex[index]
        : formVisibleIndex[index],
    [formVisibleIndex, teamDrawerMode]
  );

  const hasUnsubmittedForms = useCallback(
    teamDrawerMode &&
      (user.get('employee_forms') || []).some(
        form => !form.get('is_submitted')
      ),
    [teamDrawerMode, user]
  );

  return (
    <Box className={cx()}>
      {(!teamDrawerMode || hasUnsubmittedForms) && (
        <Box mb={8}>
          <Text
            variant="heading3"
            i18n="team.employee_profile.tax_information.title"
          />
        </Box>
      )}
      {(user.get('employee_forms') || []).map((form, index) => (
        <Box
          b={!form.get('is_submitted')}
          mb={20}
          bradius
          key={`employee-form-${index}`}
          className={cxEl('widget')}
        >
          {teamDrawerMode && !form.get('is_submitted') && (
            <Box mt={16} mb={24} ml={16} mr={16}>
              <Box mb={12} vcenter row>
                <Box>
                  <Text variant="heading3">{form.get('description')}</Text>
                </Box>

                {!form.get('is_submitted') && (
                  <Box ml={12}>
                    <Pill
                      variant={form.get('is_blocking') ? 'error' : 'warning'}
                      icon={form.get('is_blocking') ? 'Critical' : 'Warning'}
                    >
                      {toI18n('team.employee_profile.tax_information.missing')}
                    </Pill>
                  </Box>
                )}
              </Box>

              {teamDrawerMode && (
                <Box mb24>
                  <Text
                    fs16
                    i18n={
                      !form.get('is_submitted') && formVisibleIndex[index]
                        ? 'edit_team.individual_drawer.section_title.form_description'
                        : 'edit_team.individual_drawer.section_title.form_sent'
                    }
                    i18nProps={{ tax_type: form.get('description') }}
                  />
                </Box>
              )}
              <Box>
                {!teamDrawerMode && !formVisibleIndex[index] && (
                  <InfoBanner
                    user={user}
                    form={form}
                    onClickAddFormDetails={partial(
                      handleOnClickAddFormDetails,
                      index
                    )}
                  />
                )}
                {showForm(form, index) && (
                  <WithholdingForm
                    user={user}
                    form={form}
                    formIndex={index}
                    onSaveCompleted={partial(hideForm, index)}
                    onCancel={partial(hideForm, index)}
                    updateUserInfo={updateUserInfo}
                    teamDrawerMode={teamDrawerMode}
                  />
                )}
              </Box>
            </Box>
          )}
          {!teamDrawerMode && (
            <WithholdingAccordion formData={form} userData={user} />
          )}
        </Box>
      ))}
    </Box>
  );
};

TaxInformationWidget.propTypes = {
  user: ImmutablePropTypes.map.isRequired,
  updateUserInfo: PropTypes.func.isRequired,
  teamDrawerMode: PropTypes.bool,
};

export default TaxInformationWidget;
